export default {"src":"/_next/static/media/football_yellow.689feb6c.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};